module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', [_c('v-container', {
    staticClass: "inner-footer",
    attrs: {
      "grid-list-xs": "",
      "px-0": ""
    }
  }, [_c('v-layout', {
    staticClass: "mb-15",
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('div', {
    staticClass: "logo-container"
  }, [_c('img', {
    staticClass: "footer-logo",
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "src": "/static/images/nav_logo_primary.png"
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "appstore-logo-wrapper mt-6 mx-auto mx-md-0 d-flex d-md-block justify-center",
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "target": "_blank",
      "href": "https://apps.apple.com/us/app/yousound/id1452078262"
    }
  }, [_c('img', {
    staticClass: "appstore-logo",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/store.png"
    }
  })])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('h3', {
    staticClass: "mb-6"
  }, [_vm._v("About")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "flat": ""
    }
  }, _vm._l((_vm.aboutLinks), function(link) {
    return _c('v-list-tile', {
      key: link.text,
      staticClass: "pl-md-0",
      attrs: {
        "router": "",
        "href": link.route,
        "target": link.ext ? '_blank' : ''
      }
    }, [_c('v-list-tile-title', {
      staticClass: "black--text"
    }, [_vm._v(_vm._s(link.text))])], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md2": ""
    }
  }, [_c('h3', {
    staticClass: "mb-6"
  }, [_vm._v("Company")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "flat": ""
    }
  }, _vm._l((_vm.companyLinks), function(link) {
    return _c('v-list-tile', {
      key: link.text,
      staticClass: "pl-md-0",
      attrs: {
        "router": "",
        "href": link.route,
        "target": link.ext ? '_blank' : '',
        "color": "dark"
      }
    }, [_c('v-list-tile-title', {
      staticClass: "black--text"
    }, [_vm._v(_vm._s(link.text))])], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('h3', {
    staticClass: "mb-6"
  }, [_vm._v("Subscribe our Newsletter")]), _vm._v(" "), _c('form', {
    staticClass: "d-flex align-center",
    attrs: {
      "action": ""
    }
  }, [_c('input', {
    attrs: {
      "type": "email",
      "placeholder": "Your email"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "subscribe_btn"
  }, [_vm._v(" Subscribe")])], 1)])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "text-center mt-md-15"
  }, [_vm._v("© 2021 YouSound, Inc.")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16458c64","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/landingPages/Footer.vue
// module id = 1623
// module chunks = 180